import { Component, ElementRef, HostListener, EventEmitter,
  Input, Output, OnInit, ChangeDetectionStrategy, AfterViewInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { UploadOutput, UploadInput, UploadFile, humanizeBytes,
  UploaderOptions, UploadStatus } from 'ngx-uploader';

import { environment } from '../../../../../../src/environments/environment';

@Component({
  changeDetection: ChangeDetectionStrategy.Default,
  selector: 'lib-ctl-new-media-file-upload',
  templateUrl: './CtlNewMediaFileUpload.html',
  styleUrls: ['./CtlNewMediaFileUpload.css']
})

export class CtlNewMediaFileUploadComponent implements OnInit, AfterViewInit {

  showicon = 'inline';

  ctlNewFile = {};

  @Input() mediaObject: any;
  @Input() wrapperClass;
  @Input() imgClass;
  @Input() imgSource;
  @Input() fileDetail: any;
  @Input() media: boolean;
  @Input() image: boolean;
  @Input() bucket: string;
  @Input() type: string;
  @Input() allowedTypes;

  @Output() evRejected: EventEmitter<any> = new EventEmitter();
  @Output() evFileType: EventEmitter<any> = new EventEmitter();

  logoUrl: string;
  // thumb: any;

  outputFileResponse: any;

  // ngx-uploader
  options: UploaderOptions;
  uploadFile: UploadFile;
  files: UploadFile[];
  uploadInput: EventEmitter < UploadInput > ;
  humanizeBytes: Function;
  dragOver: boolean;

  urlPath = 'fs/media';

  constructor(private el: ElementRef) {}

  ngOnInit() {
    // ngx-uploader
    this.options = { concurrency: 1, allowedContentTypes: this.allowedTypes  };
    this.files = [];
    this.uploadInput = new EventEmitter < UploadInput > ();
    this.humanizeBytes = humanizeBytes;
    this.checkLogo();
  }

  ngAfterViewInit() {
    // ngx-uploader
    /*
    this.options = {
      concurrency: 1
    };
    this.files = [];
    this.uploadInput = new EventEmitter < UploadInput > ();
    this.humanizeBytes = humanizeBytes;
    */
    this.checkLogo();
  }

  @HostListener('dragover', ['$event']) public onDragOver(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.el.nativeElement.querySelector('#dropzone').style.background = '#999';
  }
  @HostListener('dragleave', ['$event']) public onDragLeave(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.el.nativeElement.querySelector('#dropzone').style.background = '#fff';
  }

  @HostListener('mouseenter') onMouseEnter() {
    this.checkLogo();
    if (this.showicon === 'none'){
      this.toggle('inline');
    }
  }

  @HostListener('mouseleave') onMouseLeave() {
    if (this.showicon === 'none'){
      this.toggle('none');
    }
  }

  private toggle(show: string) {
    if (this.el.nativeElement.querySelector('#uploadicon')) {
      this.el.nativeElement.querySelector('#uploadicon').style.display = show;
    }
  }

  fileChangeListener(event) {
    this.showicon = 'none';
    if (this.el.nativeElement.querySelector('#uploadicon')) {
      this.el.nativeElement.querySelector('#uploadicon').style.display = 'none';
    }
  }

  fileDropListener(event) {
    this.showicon = 'none';
    if (this.el.nativeElement.querySelector('#uploadicon')) {
      this.el.nativeElement.querySelector('#uploadicon').style.display = 'none';
      this.el.nativeElement.querySelector('#dropzone').style.background = '#fff';
    }
  }

  onUploadOutput(output: UploadOutput): void {
    console.log(output);
    if (output.type === 'allAddedToQueue') { // when all files added in queue
      // uncomment this if you want to auto upload files when added

      let mediaUrl = this.urlPath;
      if (this.bucket){
        mediaUrl += '/' + this.bucket;
      }

      if (this.type){
        mediaUrl += '/' + this.type;
      }

      const event: UploadInput = {
        type: 'uploadAll',
        url: environment.restAPI + mediaUrl,
        headers: {
          Authorization: 'CTL ' + localStorage.getItem('token')
        },
        method: 'POST'
      };
      this.uploadInput.emit(event);

    } else if (output.type === 'addedToQueue' && typeof output.file !== 'undefined') { // add file to array when added
      this.files.push(output.file);
    } else if (output.type === 'uploading' && typeof output.file !== 'undefined') {
      // update current data in files array for uploading file
      const index = this.files.findIndex(file => typeof output.file !== 'undefined' && file.id === output.file.id);
      this.files[index] = output.file;
    } else if (output.type === 'removed') {
      // remove file from array when removed
      this.files = this.files.filter((file: UploadFile) => file !== output.file);
    } else if (output.type === 'dragOver') {
      this.dragOver = true;
    } else if (output.type === 'dragOut') {
      this.dragOver = false;
    } else if (output.type === 'drop') {
      this.dragOver = false;
    } else if (output.type === 'rejected' && typeof output.file !== 'undefined') {
      console.log(output.file.name + ' rejected');
      this.evRejected.emit(true);
    } else if (output.type === 'done') {
      if (output.file.responseStatus === 200) {
        this.mediaObject.media = output.file.response;
        this.evRejected.emit(false);
        this.evFileType.emit(output.file.type);
      }
    }
    this.files = this.files.filter(file => file.progress.status !== UploadStatus.Done);
  }

  cancelUpload(id: string): void {
    this.uploadInput.emit({
      type: 'cancel',
      id
    });
  }

  removeFile(id: string): void {
    this.uploadInput.emit({
      type: 'remove',
      id
    });
  }

  removeAllFiles(): void {
    this.uploadInput.emit({
      type: 'removeAll'
    });
  }
  mkObject(key, value) {
    return {
      key: value
    };
  }

  checkLogo() {
    const image = this.el.nativeElement.querySelector('#ctlMediaFile');
    if (image) {
      if (this.mediaObject && this.mediaObject.media && this.mediaObject.media.thumb_url) {
        let url = this.mediaObject.media.thumb_url;
        url = url.replace('<MEDIABASEURL>', environment.msdpAPIBaseURL);
        this.toggle('none');
        image.src = url;
      } else {
        image.src = null;
        this.toggle('inline');
      }
    }
  }

}
